'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _SelectableList2 = require('components/SelectableList/SelectableList');

var _SelectableList3 = _interopRequireDefault(_SelectableList2);

var _contacts = require('redux/modules/contacts');

var contactsActions = _interopRequireWildcard(_contacts);

var _contacts2 = require('selectors/contacts');

var _GroupContactsList = require('components/GroupContacts/GroupContactsList/GroupContactsList');

var _GroupContactsList2 = _interopRequireDefault(_GroupContactsList);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GroupContactsListWrapper = (_dec = (0, _reactRedux.connect)(function (state) {
  var contactsEntities = (0, _contacts2.getFilteredGroupContactsPage)(state);
  return {
    checkedGroupContacts: state.contacts.checkedGroupContacts,
    contacts: contactsEntities.contacts,
    contactsListLoading: state.contacts.contactsListLoading,
    groupContactsListLoading: state.contacts.groupContactsListLoading,
    groupsListLoading: state.contacts.groupsListLoading
  };
}, (0, _extends3.default)({}, contactsActions)), _dec(_class = (_temp = _class2 = function (_SelectableList) {
  (0, _inherits3.default)(GroupContactsListWrapper, _SelectableList);

  function GroupContactsListWrapper() {
    (0, _classCallCheck3.default)(this, GroupContactsListWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (GroupContactsListWrapper.__proto__ || (0, _getPrototypeOf2.default)(GroupContactsListWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(GroupContactsListWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          onSelectionChange = _props.onSelectionChange,
          contacts = _props.contacts,
          onDelete = _props.onDelete,
          contactsListLoading = _props.contactsListLoading,
          groupContactsListLoading = _props.groupContactsListLoading,
          updateCheckedGroupContacts = _props.updateCheckedGroupContacts,
          checkedGroupContacts = _props.checkedGroupContacts;

      var loading = contactsListLoading || groupContactsListLoading;

      return _react2.default.createElement(_GroupContactsList2.default, {
        className: className,
        contacts: contacts,
        loading: loading,
        onDelete: onDelete,
        onSelectionChange: onSelectionChange,
        updateCheckedGroupContacts: updateCheckedGroupContacts,
        checkedGroupContacts: checkedGroupContacts
      });
    }
  }]);
  return GroupContactsListWrapper;
}(_SelectableList3.default), _class2.propTypes = {
  checkedGroupContacts: _propTypes2.default.object,
  className: _propTypes2.default.string,
  contacts: _propTypes2.default.array,
  groupContactsListLoading: _propTypes2.default.bool,
  groupsListLoading: _propTypes2.default.bool,
  onDelete: _propTypes2.default.func,
  onSelectionChange: _propTypes2.default.func,
  updateCheckedGroupContacts: _propTypes2.default.func
}, _class2.defaultProps = {
  checkedGroupContacts: {},
  contacts: [],
  onDelete: _noop3.default,
  onSelectionChange: _noop3.default,
  updateCheckedGroupContacts: _noop3.default
}, _temp)) || _class);
exports.default = GroupContactsListWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GroupContacts/GroupContactsListWrapper/GroupContactsListWrapper.js
// module id = 2017
// module chunks = 1